<template>
  <v-menu v-model="showMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
    <template #activator="{ on }">
      <slot name="activator" :on="on" v-if="hasSlot" />
      <v-text-field :label="label" v-on="on" :value="formattedDate" readonly :rules="rules" v-else />
    </template>
    <v-date-picker :value="value" @input="$emit('input', $event)" no-title :min="min" :max="max" :type="type">
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="$emit('reset')">Reset</v-btn>
      <v-btn flat color="primary" @click="showMenu = false">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: ['value', 'min', 'max', 'type', 'label', 'rules'],
  data() {
    return { showMenu: false };
  },
  computed: {
    isValidDate() {
      return this.value && new Date(this.value) >= new Date('1900-01-01T00:00:00Z');
    },
    formattedDate() {
      return this.value && this.dateFormat(this.value) || '';
    },
    hasSlot() {
      return this.$slots.activator;
    },
  },
  mounted() {
    if (!this.isValidDate)
      this.$emit('input', null);
  },
};
</script>
